var map = {
	"./AmericanPancakes.jpg": 85,
	"./AmericanPancakes2.jpg": 86,
	"./React.png": 87,
	"./bananaKiwiIceCream.jpg": 88,
	"./bananaSmoothie.jpg": 89,
	"./bluf.JPG": 90,
	"./french-fries.jpg": 91,
	"./ice-cream-cone.jpg": 92,
	"./logo.svg": 93,
	"./pancakes1.jpg": 94,
	"./pexels-alexy-almond-3756659.jpg": 95,
	"./pexels-olya-kobruseva-6507004.jpg": 96,
	"./pexels-rodnae-productions-8581368.jpg": 97,
	"./pizza2.jpg": 98,
	"./salad.jpg": 99,
	"./spongeCake.jpg": 100,
	"./tortilla.jpg": 101,
	"./tortilla2.jpg": 102,
	"./vegetarian-mark-90.png": 69
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68;